/* lua.js generated code 0.3.0 */

require("clover/ui/UIItemBuilder")
require("clover/panel/component/common/uiGroupButtonLayout/UIGLabelButton")
require("clover/panel/component/common/uiGroupButtonLayout/UIGIconNumLabelButton")
require("clover/panel/component/common/uiButtonAnims/PushBounceIdleShakeAnim")
require("clover/panel/component/bagpanel/PropBagAnimation")
require("clover/animation/ui/HomeSceneAnimation")
let { needHideRewardNum } = require("./MarkViewUtil")

let SnsProxy = require("clover/sns/SnsProxy")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")

var RemarkPanel = xClass("RemarkPanel", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/mark_panel_3_remarkpanel_remarkpanel.csb")
})

var RemarkPanelEvent = table(
    [1, "AdRemark", "REMARKPANELEVENT.ADREMARK"],
    [1, "CoinRemark", "REMARKPANELEVENT.COINREMARK"],
    [1, "Close", "REMARKPANELEVENT.CLOSE"],
)

RemarkPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
}

/**
 * @param 
 */
RemarkPanel.prototype.ctor = function (config) {
    var self = this
    BasePanel.prototype.ctor.call(self)
    self.config = config
    self.buildUI()
}

RemarkPanel.prototype.buildUI = function () {
    var self = this

    //  关闭按钮
    self.btnClose = self.getChildByName("btn_close")
    self.btnClose = UIGroupButton.create(self.btnClose, true)
    self.btnClose.on(UIButtonEvent.Click, function () {
        self.onClose()
    })

    //  Tip
    self.tip = self.getChildByName("txt");
    self.tip.setFontSize(26);

    //  补签按钮
    self.btnVideoRemark = self.getChildByName("btn_green_ad")
    self.btnVideoRemark.x -= 10
    self.btnCoinRemark = self.getChildByName("btn_blue_add")
    if (self.config.canVideoRemark) {
        //  视频补签
        self.btnCoinRemark.setVisible(false)

        self.btnVideoRemark = UIGroupButton.create(self.btnVideoRemark, true)
        self.btnVideoRemark.on(UIButtonEvent.Click, function () {
            self.dispatchEvent(table([1, "name", RemarkPanelEvent.AdRemark],
            [1, "day", self.config.day],
            [1, "isVideoRemark", true]))
        })
        self.btnVideoRemark.setAnchorPoint(0.5, 0)
        let size = self.btnVideoRemark.getContentSize()
        self.btnVideoRemark.x += size.width / 2
        var label = self.btnVideoRemark.getChildByName("label")
        label.setString("免费补签")
        label.x += 27
        ButtonPushBounceAnim.create(self.btnVideoRemark)
        ButtonPushBounceIdleBubbleAnim.create(self.btnVideoRemark)
        DYAdUtil.modifyIconAttribute(self.btnVideoRemark.getChildByName("icon"),self.btnVideoRemark,{
        });
        if (DYAdUtil.isOpen()){
            self.btnVideoRemark.setVisible(false)
    
            let posX = this.btnVideoRemark.x
            let posY = this.btnVideoRemark.y - 50
    
            let btnCancel = DYAdUtil.createBtn({
                txt:"取消",
                size: cc.size(210,110),
                type: 2,
            },false,()=>{
                this.onClose()
            });
            btnCancel.setPosition(cc.p(posX - 120,posY))
            this.addChild(btnCancel)
    
            
            let btnConfirm = DYAdUtil.createBtn({
                txt:"补签",
                size: cc.size(210,110),
                type: 1,
            },true,()=>{
                self.dispatchEvent(table([1, "name", RemarkPanelEvent.AdRemark],
                [1, "day", self.config.day],
                [1, "isVideoRemark", true]))
            });
            btnConfirm.setPosition(cc.p(posX + 120,posY))
            this.addChild(btnConfirm)
        }
        DCAssist.dc4User101("mark","supplement_ad_button_show",{session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`})
    } else {
        //  风车币补签
        self.btnVideoRemark.setVisible(false)

        self.btnCoinRemark = UIGroupButton.create(self.btnCoinRemark, true)
        self.btnCoinRemark.on(UIButtonEvent.Click, function () {
            self.dispatchEvent(table([1, "name", RemarkPanelEvent.CoinRemark],
            [1, "day", self.config.day],
            [1, "isVideoRemark", false]))
        })
        var offset = 20
        var label = self.btnCoinRemark.getChildByName("label")
        label.setString("补签")
        label.x += offset
        var icon = self.btnCoinRemark.getChildByName("icon")
        icon.setSpriteFrame(UIItemBuilder.createPropIcon(14).getSpriteFrame())
        icon.setAnchorPoint(0.35, 1)
        icon.x += offset
        var num = self.btnCoinRemark.getChildByName("num")
        num.x += offset
        num.setString(self.config.remarkPrice)
        ButtonPushBounceAnim.create(self.btnCoinRemark)
        ButtonPushBounceIdleBubbleAnim.create(self.btnCoinRemark)
    }

    //  补签奖励
    self.reward = self.getChildByName("reward")
    if (self.config.mark_reward.length == 0) {
        //  没有奖励，肯定是配置错了，那也什么都不显示
        self.reward.setVisible(false)
    } else if (self.config.mark_reward.length >= 1) {
        //  单个奖励，目前来说是正常配置
        self.rewardNode = [];
        for (var i = 0; i < self.config.mark_reward.length; i++) {
            if (i == 0) {
                self.rewardNode.push(RemarkPanel.createReward(self.config.mark_reward[i], self.reward));
            } else {
                var node = RemarkPanel.createReward(self.config.mark_reward[i])
                self.addChild(node);
                self.rewardNode.push(node);
            }
        }
        if (self.config.markedDay == 6) {
            for (var i = 0; i < self.config.fullMarkReward.length; i++) {
                var node = RemarkPanel.createReward(self.config.fullMarkReward[i]);
                self.addChild(node);
                self.rewardNode.push(node);
            } 
        }
        //  调整节点位置
        var middleX = self.rewardNode[0].x;
        var posY = self.rewardNode[0].y;
        var scale = self.rewardNode[0].getScale();
        for (var i = 0; i < self.rewardNode.length; i++) {
            self.rewardNode[i].x = middleX + (i - (self.rewardNode.length - 1) / 2) * 140;
            self.rewardNode[i].setScale(scale);
            self.rewardNode[i].y = posY;
        }
    }
}

/**
 * 创建奖励节点
 * @param config    奖励信息
 * @param node      是否使用已存在的节点
 */
RemarkPanel.createReward = function(config, node = null) {

    if (node) {
        var rewardNode = node;
    } else {
        var rewardNode = cc.CSLoader.createNode("cocos/mark_panel_3_amount_vigor.csb");
    }
    var reward = config.split(':')
    //  物品图标
    var propMeta = MetaManager.getInstance().getPropMeta(reward[0])
    var icon = rewardNode.getChildByName("icon")
    var num = rewardNode.getChildByName("num")
    if (propMeta && propMeta.expireTime !== 0) {
        propIcon = UIItemBuilder.createPropIcon(reward[0], (Localhost.time() + propMeta.expireTime))
        //propIcon.setPosition(icon.getPostion)
        propIcon.x = icon.x
        propIcon.y = icon.y
        propIcon.setAnchorPoint(icon.getAnchorPoint())
        propIcon.setName(icon.getName())
        propIcon.setScale(icon.getScale())
        icon.removeFromParent(true)
        rewardNode.addChild(propIcon)
        num.setLocalZOrder(propIcon.getLocalZOrder() + 1)
    } else {
        rewardNode.getChildByName("icon").setSpriteFrame(UIItemBuilder.createPropIcon(reward[0]).getSpriteFrame())
    }
    num.setString(reward[1])
    num.setNextFontPositionXOffset(-4)
    //  如果奖励是货币，则需要调整一下数量位置
    if (RemarkPanel.rewardIsCurrency(reward[0])) {
        num.x -= 5 * reward[1].length;
        num.y -= 7
    } else {
        num.x += 5
        num.y -= 7
    }
    var action = cc.CSLoader.createTimeline("cocos/mark_panel_3_stargolow000all.csb");
    rewardNode.getChildByName("effect").runAction(action)
    action.gotoFrameAndPlay(0, true);
    if (needHideRewardNum(reward[0])) {
        //  如果是10分钟无限精力瓶则不显示数量
        rewardNode.getChildByName("num").setVisible(false)
    }

    return rewardNode
}

RemarkPanel.prototype.onClose = function (callback) {
    var self = this

    self.dispatchEvent(table([1, "name", RemarkPanelEvent.Close]))
    BasePanel.prototype.onClose.call(self, callback)
}

RemarkPanel.rewardIsCurrency = function (rewardId) {
    if (rewardId == GamePropIds.kCoin || rewardId == GamePropIds.kCash) {
        return true
    } else {
        return false
    }
}

RemarkPanel.prototype.popup = function (dark, canTouchBehind, callback) {
    var self = this

    self.x -= 170
    BasePanel.prototype.popup.call(self, dark, canTouchBehind, function () {
        if (callback) {
            callback()
        }
    })
}

module.exports = {
    RemarkPanel,
    RemarkPanelEvent
}
